var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.audioSource !== '')?_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.audioSource,"type":"audio/mpeg"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }